<template>
    <div>
        <page-title>商盟管理</page-title>
        <page-body>
            <list-header>
                <div flex="dir:left box:last cross:center">
                    <div>
                        <router-link to="/dashboard/admin/mch/level">
                            <el-button type="text">商盟等级管理</el-button>
                        </router-link>
                    </div>
                    <div>
                        <el-input size="mini"
                                  clearable
                                  v-model="search.keyword"
                                  placeholder="关键字检索"
                                  suffix-icon="el-icon-search"
                                  @keyup.enter.native="loadData"></el-input>
                    </div>
                </div>
            </list-header>
            <el-table v-loading="search.loading" :data="list" style="width: 100%">
                <el-table-column prop="id" label="ID" width="80"></el-table-column>
                <el-table-column prop="mobile" label="商盟">
                    <template slot-scope="scope">
                        <div>姓名: {{scope.row.name}}</div>
                        <div>公司: {{scope.row.org_name}}</div>
                        <div>等级: {{scope.row.level ? scope.row.level.name : '-'}}</div>
                        <view-certificate v-if="scope.row.certificate_url" v-model="scope.row.certificate_url" :mark="scope.row.mark"></view-certificate>
                    </template>
                </el-table-column>
                <el-table-column prop="mobile" label="联系方式">
                    <template slot-scope="scope">
                        <div>手机号: {{scope.row.mobile}}</div>
                        <div>QQ号: {{scope.row.qq_id?scope.row.qq_id:'-'}}</div>
                        <div>微信号: {{scope.row.wechat_id?scope.row.wechat_id:'-'}}</div>
                    </template>
                </el-table-column>
                <el-table-column prop="mobile" label="站点/插件/代理">
                    <template slot-scope="scope">
                        <div>站点数: {{scope.row.host_count}}</div>
                        <div>插件订单: {{scope.row.plugin_order_count}}</div>
                        <div>代理数: {{scope.row.agent_count}}</div>
                    </template>
                </el-table-column>
                <el-table-column prop="add_time" label="时间">
                    <template slot-scope="scope">
                        <div>添加: {{scope.row.add_time}}</div>
                        <div>更新: {{scope.row.update_time}}</div>
                    </template>
                </el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <template v-if="scope.row.is_delete === 0">
                            <template v-if="scope.row.status === 0">
                                <el-button type="text" @click="update(scope, {status: 1})">审核通过</el-button>
                                <span class="text-split">|</span>
                            </template>
                            <router-link :to="'/dashboard/admin/mch/edit?id=' + scope.row.id">编辑</router-link>
                            <span class="text-split">|</span>
                            <el-button type="text" @click="update(scope, {is_delete: 1})">删除</el-button>
                        </template>
                        <template v-else>
                            <span style="color: #909399">已删除</span>
                            <span class="text-split">|</span>
                            <el-button type="text" @click="update(scope, {is_delete: 0})">恢复</el-button>
                        </template>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination v-if="pagination"
                           style="margin: 20px -5px;padding: 0"
                           background
                           layout="prev, pager, next"
                           :total="pagination.totalCount"
                           :page-size="pagination.pageSize"
                           @current-change="page=>{search.page=page;loadData();}"></el-pagination>
        </page-body>
    </div>
</template>

<script>
import axios from '@/axios'

export default {
    components: {
        'ViewCertificate': () => import('@/components/ViewCertificate.vue')
    },
    data() {
        return {
            search: {
                page: 1,
                keyword: '',
                loading: false
            },
            list: null,
            pagination: null
        }
    },
    created() {
        this.loadData(0)
    },
    methods: {
        loadData() {
            this.search.loading = true
            axios({
                url: 'admin/mch/list',
                params: {
                    page: this.search.page,
                    keyword: this.search.keyword
                }
            }).then(e => {
                this.search.loading = false
                if (e.data.code === 0) {
                    this.list = e.data.data.list
                    this.pagination = e.data.data.pagination
                } else {
                    this.$message.error(e.data.msg)
                }
            })
        },
        update(scope, data) {
            this.$confirm('确认操作？', '提示').then(() => {
                data['id'] = scope.row.id
                axios({
                    url: 'admin/mch/update',
                    method: 'post',
                    data: data
                }).then(e => {
                    if (e.data.code === 0) {
                        this.$message.success('操作成功')
                    } else {
                        this.$message.error(e.data.msg)
                    }
                }).catch(() => {
                })
            }).catch(() => {
            })
        }
    }
}
</script>

<style scoped>

</style>
